import { render, staticRenderFns } from "./ProjectWebsiteEditPagesTab.vue?vue&type=template&id=28d77a16"
import script from "./ProjectWebsiteEditPagesTab.vue?vue&type=script&lang=ts"
export * from "./ProjectWebsiteEditPagesTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectWebsiteEditPagesTab.vue?vue&type=style&index=0&id=28d77a16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports